import script from "./FELProviders.vue?vue&type=script&setup=true&lang=js"
export * from "./FELProviders.vue?vue&type=script&setup=true&lang=js"

import "./FELProviders.vue?vue&type=style&index=0&id=4fa64fe6&lang=css"

const __exports__ = script;

export default __exports__